<table>
  <thead>
  <tr>
    <th rowspan="2" class="rank"></th>
    <th rowspan="2" class="img"></th>
    <th rowspan="2" class="team-name">{{ 'standings.table.teams' | translate }}</th>
    <th rowspan="2" class="record">{{ 'standings.table.record' | translate }}</th>
    <th colspan="2">{{ 'standings.table.map' | translate }}</th>
  </tr>
  <tr>
    <th class="record">{{ 'standings.table.win_pct' | translate }}</th>
    <th class="record">{{ 'standings.table.record' | translate }}</th>
  </tr>
  </thead>
  <tbody>
    @for (standings of standingsList; track standings; let index = $index) {
      <tr [class]="{'current-player': standings.current_team_member}">
        <td class="rank">{{index + 1}}</td>
        <td class="img">
          <div class="profile_image"><img src="{{utils.teamImageUrl(standings)}}" alt="Team"/></div>
        </td>
        <td class="team-name">{{standings.team_name}}</td>
        <td class="record">
          @if(standings.forfeit) {
            {{ 'standings.table.ff' | translate }}
          }
          @else {
            {{standings.game_wins}} - {{standings.game_losses}}
          }
        </td>
        <td class="record">{{standings.map_wins_percent | number:'1.0-0'}}</td>
        <td class="record">{{standings.map_wins}} - {{standings.map_losses}}</td>
      </tr>
    }
  </tbody>
</table>
